import { Tooltip, Typography } from "@material-ui/core";

type EllipsisTextProps = {
  text: string;
  maxLength?: number;
  ignoreMaxLength?: boolean;
};

/**
 * 長い文字列を省略して表示するコンポーネントです。<br />
 * マウスホバーするとツールチップが出ます。
 */
export const EllipsisText: React.FC<EllipsisTextProps> = ({
  text,
  maxLength = 20,
  ignoreMaxLength = false,
}) => {
  const omittedText =
    ignoreMaxLength === false && maxLength < text.length
      ? text.substring(0, maxLength) + "..."
      : text;

  return (
    <>
      <Tooltip
        title={<Typography component="h6">{text}</Typography>}
        placement="top-start"
        enterDelay={300}
      >
        <Typography
          style={{
            writingMode: "horizontal-tb",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-all",
          }}
        >
          {omittedText}
        </Typography>
      </Tooltip>
    </>
  );
};
